export const crmSubscriptionColumns = [
  {
    title: 'Тариф',
    dataIndex: 'plan',
    sorter: true,
    width: '10%',
  },
  {
    title: 'Цена',
    dataIndex: 'price',
    sorter: true,
    width: '10%',
  },
  {
    title: 'Статус',
    dataIndex: 'status',
    sorter: true,
    width: '10%',
  },
  {
    title: 'Начало',
    dataIndex: 'startDate',
    sorter: true,
    width: '15%',
  },
  {
    title: 'Конец',
    dataIndex: 'endDate',
    sorter: true,
    width: '15%',
  },
  {
    title: 'Дата',
    dataIndex: 'updatedAt',
    sorter: true,
    width: '15%',
  },
]
